import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

let startX;
let startY;
let dist;
let threshold = 150;
let allowedTime = 200;
let elapsedTime;
let startTime;
const HeaderWrapper = ({ children, location, history, menu }) => {
  const handleSwipe = (isSwiped, isRight) => {
    if (isSwiped) {
      if (menu && menu.length > 0) {
        const index = menu.indexOf(location.pathname);
        if (index !== -1) {
          if (index > 0 && !isRight) {
            history.push(menu[index - 1]);
          }
          if (index < menu.length - 1 && isRight) {
            history.push(menu[index + 1]);
          }
        }
      }
    }
  };

  const onTouchEnd = e => {
    const touchobj = e.changedTouches[0];
    dist = touchobj.pageX - startX;
    elapsedTime = new Date().getTime() - startTime;
    const swipeBol =
      elapsedTime <= allowedTime &&
      Math.abs(dist) >= threshold &&
      Math.abs(touchobj.pageY - startY) <= 100;
    handleSwipe(swipeBol, dist >= 0);
  };

  const onTouchStart = e => {
    const touchobj = e.changedTouches[0];
    dist = 0;
    startX = touchobj.pageX;
    startY = touchobj.pageY;
    startTime = new Date().getTime();
  };
  return (
    <Wrapper onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      {children}
    </Wrapper>
  );
};

HeaderWrapper.propTypes = {
  children: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any,
  menu: PropTypes.any,
};

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;

  > div:first-child {
    > div:first-child {
      > div:last-child {
        @media screen and (min-width: 768px) {
          display: flex;
        }
      }
    }
  }
`;

export default withRouter(HeaderWrapper);
